// Angular
import { Component, OnInit, effect, inject, ChangeDetectionStrategy } from '@angular/core';
// Material
import { MatDialog } from '@angular/material/dialog';
import { MatTooltip } from '@angular/material/tooltip';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
// Rxjs & Lodash
import { toUpper } from 'lodash';
// Service
import { LayoutService } from '../services';
// Transloco
import { TranslocoService } from '@jsverse/transloco';
// Component
import { VisitorSettingDialogComponent } from './visitor-setting-dialog/visitor-setting-dialog.component';

@Component({
  selector: 'app-visitor-setting',
  templateUrl: './visitor-setting.component.html',
  styleUrls: ['./visitor-setting.component.scss'],
  host: { ngSkipHydration: 'true' },
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatTooltip, MatProgressSpinner],
})
export class VisitorSettingComponent implements OnInit {
  // Private
  private readonly dialog = inject(MatDialog);
  private readonly layoutService = inject(LayoutService);
  private readonly translocoService = inject(TranslocoService);

  // Public
  country: any;
  language: any;
  currency: string;
  customerType: string;
  infoToolTip: string;

  constructor() {
    effect(() => {
      this.customerType = this.layoutService.customerTypeSignal();
      if (this.language && this.country && this.currency) {
        const typeLabel =
          this.customerType === '1'
            ? this.translocoService.translate('label_private')
            : this.translocoService.translate('label_business');
        this.infoToolTip = `${toUpper(this.language?.language)} / ${toUpper(this.country?.name)} / ${toUpper(this.currency)} / ${toUpper(typeLabel)}`;
      }
    });
  }

  /**
   * On Init
   * @memberof VisitorSettingComponent
   */
  ngOnInit(): void {
    // get country
    this.country = this.layoutService.getCurrentCountry();
    // get language code
    this.language = this.layoutService.getCustomerLanguageCode();
    // get currency
    this.currency = this.layoutService.getCustomerCurrency();
  }

  /**
   * On Open Visitor Setting Dialog
   * @memberof VisitorSettingComponent
   */
  onOpenSettingDialog(): void {
    this.dialog.open(VisitorSettingDialogComponent);
  }
}
